import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import ReducerConstants from '../../_shared/constants/reducers';
import { TradeContext } from '../../_shared/types/trade';
import { updateActivePrimary } from '../../redux/slices/ui/nav';
import NavSecondary from '../../components/NavSecondary';
import ROUTES from '../../components/Routes/constants';
import RouteExternal from '../../components/Routes/RouteExternal';
import Vdp from '../../components/Vdp';
import StyledVdp from './Styles';

const Trade = () => {
  const { tradeId } = useParams();
  const dispatch = useDispatch();
  const [{ context, items }, tradeDetails, auth] = useSelector(
    state => [
      state?.ui?.nav?.primary,
      state[ReducerConstants.TRADE_DETAILS],
      state[ReducerConstants.AUTH]
    ],
    shallowEqual
  );

  const getItemTestIdByContext = contextRequired => {
    const item = items.find(i => i.context === contextRequired);
    if (!item) return null;
    return item.testId;
  };

  useEffect(() => {
    let newContext = TradeContext.Buy;
    if (auth?.user?.companyId === tradeDetails?.dealer?.id) {
      newContext = TradeContext.Sell;
    }

    const selector = `li[name=${getItemTestIdByContext(newContext)}]>a`;
    const el = document.querySelector(selector);

    if (el && context !== newContext) {
      const { left, width } = el.getBoundingClientRect();
      dispatch(updateActivePrimary({ context: newContext, width, left }));
    }
  }, [auth?.user, tradeDetails, context]); //eslint-disable-line

  if (!tradeId) {
    return <RouteExternal link={ROUTES.TR4_ENDPOINT} />;
  }

  return (
    <>
      <NavSecondary tradeState={tradeDetails?.tradeState} />

      <StyledVdp>
        <Vdp tradeId={parseInt(tradeId, 10)} tradeContext={context} />
      </StyledVdp>
    </>
  );
};

export default Trade;
